import { createAction } from '@reduxjs/toolkit'

export const setStats = createAction<{ stats: any }>('home/setStats')

export const setVaultsList = createAction<{ vaultsList: any }>('home/setVaultsList')
